<template>
  <div class="citrix-virtual" style="padding:0%;margin:0%">
    <div class="left-header" style="flex-grow: 7">
      <div class="portal-header">
        <p class="title-cell">Citrix DaaS Standard for Google Cloud</p>
        <p class="title-cell mt-0">with your Google Cloud consumption</p>
      </div>
      <div class="mobile-header">
        <p class="title-cell">
          Citrix DaaS Standard for Google Cloud with your Google Cloud
          consumption
        </p>
      </div>
    </div>
    <div class="right-tile" style="flex-grow: 2">
      <p class="cell-item">Regions</p>
      <p class="cell-data">{{ data.regions }}</p>
    </div>
    <div class="right-tile" style="flex-grow: 2">
      <p class="cell-item">User types</p>
      <p class="cell-data">{{ data.personas }}</p>
    </div>
    <div class="right-tile" style="flex-grow: 2">
      <p class="cell-item">Users</p>
      <p class="cell-data">{{ data.users }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HorizontalTile',

  props: {
    data: {
      type: Object,
      require: true,
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  margin-top: 0%;
  padding: 0%;
}
.citrix-virtual {
  margin-top: 45px;
  background-color: $secondary;
  box-shadow: 0px 4px 16px 0px #0000000d;
  border: 1px solid rgba(177, 177, 177, 0.25);
  border-radius: 8px;
  display: flex;

  @media screen and (max-width: 600px) {
    display: block;
  }

  .right-tile {
    padding-left: 18px;
    padding-top: 18px;
    padding-bottom: 22px;
    border-left: 1px solid rgba(177, 177, 177, 0.25);
  }
}

.title-cell {
  color: #000;
  font-size: 24px;
}

.cell-item {
  font-size: 20px;
  width: max-content;
}

.left-header {
  padding-left: 18px;
  padding-top: 18px;
  padding-bottom: 22px;

  .mobile-header {
    display: none;
  }

  @media screen and (max-width: 600px) {
    .portal-header {
      display: none;
    }
    .mobile-header {
      display: block;
    }
  }
}

@media screen and (min-width: 601px) {
  .cell-data {
    font-size: 28px;
    margin-top: 0;
    margin-bottom: 2px;
  }
}

@media screen and (max-width: 600px) {
  .cell-data {
    font-size: 24px;
    margin-top: 0;
    margin-bottom: 20px;
  }
  .citrix-virtual {
    height: auto;
  }
}

.text-lighter {
  font-weight: 100;
  font-size: 20px;
  color: $light;
}
</style>
